


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyCSNw18mStYpeyPIrooQBnYSXHArQiTtJo",
  authDomain: "batticaloa-opticals-2nd.firebaseapp.com",
  projectId: "batticaloa-opticals-2nd",
  storageBucket: "batticaloa-opticals-2nd.firebasestorage.app",
  messagingSenderId: "103983574355",
  appId: "1:103983574355:web:aece2a91ef924cc2b105a6"
};


const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export